// src/HeatmapCalendar.js
import React, { useState } from "react";
import "./HeatmapCalendar.css";

const HeatmapCalendarOld = ({ tradeData, newCurrentYear }) => {
  

  // let tradeData = tradeData
  // let tradeData = tradeData.flatMap((obj) => obj.day_wise_pnl);

  // Sort the combined array by date in ascending order
  tradeData.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Find the earliest date in tradeData
  const startDate = tradeData.length > 0 ? tradeData[0].date : null;

  // Helper function to get the earliest date from tradeData
  const getEarliestDate = () => {
    const dates = tradeData.map((trade) => new Date(trade.date));
    return dates.length > 0 ? new Date(Math.min(...dates)).toISOString() : null;
  };

  // Helper function to format date as yyyy-mm
  const formatMonth = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0].slice(0, 7);
  };

  // Determine the start date based on the earliest date in tradeData
  const earliestDate = getEarliestDate();
  const startYear = earliestDate ? new Date(earliestDate).getFullYear() : 2024;

  // Create an array of months
  const allMonths = Array.from({ length: 12 }, (_, index) => {
    const year = newCurrentYear;
    const month = (index + 1) % 12 || 12;
    return `${year}-${month < 10 ? "0" : ""}${month}`;
  });

  // Replace this data with your actual trade data
  // const tradeData = [
  //   { date: "2024-01-01", profit: 100 },
  //   { date: "2024-01-05", profit: -500 },
  //   { date: "2024-01-15", profit: -20 },
  //   { date: "2024-01-19", profit: 221 },
  //   { date: "2024-01-20", profit: 3000 },
  //   { date: "2024-01-22", profit: -350 },
  //   { date: "2024-01-24", profit: -150 },
  //   // Add more data as needed
  // ];

  // // Helper function to format date as yyyy-mm
  // const formatMonth = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toISOString().split("T")[0].slice(0, 7);
  // };

  // // Create an array of months
  // const allMonths = Array.from({ length: 12 }, (_, index) => {
  //   const year = 2024; // Replace with your desired year
  //   const month = index + 1;
  //   return `${year}-${month < 10 ? "0" : ""}${month}`;
  // });

  // Define the days of the week
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div className="heatmap-calendar  w-full space-x-[8px] ">
      {/* <div className="flex flex-col m-[4px] justify-end space-y-[2px]">
        {daysOfWeek.map((day) => (
          <div
            key={day}
            className="flex w-6 h-4 text-xs font-semibold text-white"
          >
            {day}
          </div>
        ))}
      </div> */}
      {allMonths.map((month) => {
        const daysInMonth =
          new Date(month + "-01T00:00:00").getMonth() !== 11
            ? new Date(
                new Date(month + "-01T00:00:00").getFullYear(),
                new Date(month + "-01T00:00:00").getMonth() + 1,
                0
              ).getDate()
            : 31; // Handle December case

        const monthTradeData = tradeData.filter(
          (trade) => formatMonth(trade.date) === month
        );

        return (
          <div key={month} className="heatmap-month">
            <div className="text-sm font-semibold text-white">
              {new Date(month + "-01").toLocaleString("default", {
                month: "short",
              })}
            </div>
            {Array.from({ length: 7 }, (_, weekIndex) => (
              <div key={weekIndex} className="heatmap-week">
                {Array.from({ length: 5 }, (_, dayIndex) => {
                  // const day = weekIndex * 5 + dayIndex + 1;
                  const day = (dayIndex + 1 - 1) * 7 + (weekIndex + 1);
                  if (day <= daysInMonth) {
                    const date = `${month}-${day < 10 ? "0" : ""}${day}`;
                    const trade = monthTradeData.find(
                      (item) => item.date === date
                    );

                    let profitClass = "";
                    if (trade) {
                      const profit = trade.profit;
                      if (profit > 0 && profit < 500) {
                        profitClass = "profit-1";
                      } else if (profit >= 500 && profit < 5000) {
                        profitClass = "profit-2";
                      } else if (profit >= 5000 && profit < 10000) {
                        profitClass = "profit-3";
                      } else if (profit >= 10000) {
                        profitClass = "profit-4";
                      } else if (profit < 0 && profit > -500) {
                        profitClass = "loss-1";
                      } else if (profit <= -500 && profit > -5000) {
                        profitClass = "loss-2";
                      } else if (profit <= -5000 && profit > -10000) {
                        profitClass = "loss-3";
                      } else if (profit <= -10000) {
                        profitClass = "loss-4";
                      }
                    } else {
                      profitClass = "no-data";
                    }

                    return (
                      <div
                        key={date}
                        className={`relative group heatmap-day ${profitClass}`}
                      >
                        <p className="hidden group-hover:block absolute min-w-[120px] -top-[60px] -left-[30px]  bg-[#222121] text-white px-2 py-2 rounded-md z-50 font-semibold text-[10px">
                          {/* {trade
                            ? `${date} : ${
                                trade.profit >= 0
                                  ? `₹${trade.profit}`
                                  : `-₹${Math.abs(trade.profit)}`
                              }`
                            : date} */}

                          {trade ? (
                            <span>{`${date} : ${
                              trade.profit >= 0
                                ? `₹${trade.profit}`
                                : `-₹${Math.abs(trade.profit)}`
                            }`}</span>
                          ) : (
                            <span>{date}</span>
                          )}
                        </p>
                      </div>
                    );
                  } else {
                    return (
                      <div key={dayIndex} className="heatmap-day disabled" />
                    );
                  }
                })}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default HeatmapCalendarOld;
